import { Controller } from '@hotwired/stimulus';

/*
  Permite abrir una nueva ventana para poder cerrarla después con el componente AutoCloseButton
*/
export default class extends Controller {
  connect() {
    this.windowReference = null;

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      const link = e.currentTarget;
      this.windowReference = window.open(link.href, link.id);
    });
  }
}
